import { ACTIONS } from "../actions/admin-delivery";
import moment from "moment";
import { ca } from "date-fns/locale";

const tableGame = [
    {
        item: [
            {
                text: '巨人'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: '阪神'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: '中日'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: '広島'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: 'team/DeNA'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: 'ヤクルト'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    }
];
const tableGame1 = [
    {
        item: [
            {
                text: '阪神'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: '巨人'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: '広島'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: '中日'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: 'team/DeNA'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    },
    {
        item: [
            {
                text: 'ヤクルト'
            },
            {
                text: ''
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
            {
                text: {
                    name: 'X-X ヤクルト',
                    action: '先発投手'
                }
            },
        ]
    }
];
const headerGame = ['チーム', '08/03', '08/04', '08/05', '08/06', '08/07', '08/08', '08/09'];
const data = [
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            status: '納品済',
            dot: false
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            status: '納品済',
            dot: true
        }
    },
    {
        item: {
            title: 'ワークスペースタイトル',
            name: 'クライアント名, クライアント名, クライアン...',
            status: '納品済',
            dot: true
        }
    }
];
const header2 = ['', 'タイトル', 'カテゴリー', '対象', '作成日時', '更新日時', 'ステータス'];
const table = [
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { text: '作業中', dot: 'red' },
            {
                action: [
                    'このワークスペースにコピー', '他のワークスペースにコピー', '削除'
                ]
            }
        ]
    },
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { text: '作業中', dot: 'orange' },
            {
                action: [
                    'このワークスペースにコピー', '他のワークスペースにコピー', '削除'
                ]
            }
        ]
    },
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { text: '作業中', dot: 'orange' },
            {
                action: [
                    'このワークスペースにコピー', '他のワークスペースにコピー', '削除'
                ]
            }
        ]
    },
    {
        item: [
            { text: 'Topicsタイトル' },
            { text: 'Game Topics' },
            { text: '8/3 巨人 - 中日' },
            { text: '2019/11/23 12:34' },
            { text: '2019/11/23 12:34' },
            { text: '作業中', dot: 'green' },
            {
                action: [
                    'このワークスペースにコピー', '他のワークスペースにコピー', '削除'
                ]
            }
        ]
    }
];


export default (state = {
    tableGame, headerGame,
    data, header2, table, tableGame1
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_ADMIN_DELIVERY_SUCCESS:
        case ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_SUCCESS:
        case ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS:
        case ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS:
        case ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS:
        case ACTIONS.DELETE_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS:
        case ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_SUCCESS:
        case ACTIONS.COPY_WORKSPACE_SUCCESS:
        case ACTIONS.EDIT_WORKSPACE_SUCCESS:
        case ACTIONS.DELETE_TOPICS_SUCCESS:
        case ACTIONS.DELETE_WORKSPACE_SUCCESS:
        case ACTIONS.GET_ALL_TEAM_SUCCESS:
        case ACTIONS.CREATE_TOPIC_SUCCESS:
        case ACTIONS.GET_LIST_PLAYER_TOPIC_SUCCESS:
        case ACTIONS.GET_CUSTOMERS_SUCCESS:
        case ACTIONS.ADD_WS_GET_CUSTOMERS_SUCCESS:
        case ACTIONS.OPEN_TOPIC_WORKSPACE_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_LIST_GAMES_SUCCESS:
            return {
                ...state,
                st: action.type,
                res: action.data,
                payload: action.payload
            };
        case ACTIONS.GET_DATA_ADMIN_DELIVERY_ERROR:
        case ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_ERROR:
        case ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ERROR:
        case ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_ERROR:
        case ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_FILES_ERROR:
        case ACTIONS.DELETE_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_ERROR:
        case ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_ERROR:
        case ACTIONS.GET_LIST_GAMES_ERROR:
        case ACTIONS.COPY_WORKSPACE_ERROR:
        case ACTIONS.DELETE_TOPICS_ERROR:
        case ACTIONS.EDIT_WORKSPACE_ERROR:
        case ACTIONS.DELETE_WORKSPACE_ERROR:
        case ACTIONS.GET_ALL_TEAM_ERROR:
        case ACTIONS.CREATE_TOPIC_ERROR:
        case ACTIONS.GET_LIST_PLAYER_TOPIC_ERROR:
        case ACTIONS.GET_CUSTOMERS_ERROR:
        case ACTIONS.ADD_WS_GET_CUSTOMERS_ERROR:
        case ACTIONS.OPEN_TOPIC_WORKSPACE_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};